import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import API from '../config';

const GoogleAuthSuccess = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    // ✅ FIXED: Read token from hash fragment, not query string
    const hash = window.location.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const token = params.get('token');

    if (!token) {
      navigate('/login?error=google');
      return;
    }

    axios.get(`${API}/api/users/profile`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        login(res.data, token);
        // ✅ FIXED: Route to nickname picker if no username set yet
        if (!res.data.username) {
          navigate('/setup-nickname');
        } else {
          navigate('/dashboard');
        }
      })
      .catch(() => {
        navigate('/login?error=google');
      });
  }, [navigate, login]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif" }}>
      <p style={{ color: '#888', fontSize: 14 }}>Signing you in...</p>
    </div>
  );
};

export default GoogleAuthSuccess;